export default function formTrimInput() {
  $("body").on("submit", "form", function () {
    $(this)
      .find("[data-trim-input]")
      .each(function () {
        this.value = this.value.trim()
      })
  })
}
